"use strict";

angular.module('rmBlades')
	.controller('BladesCtrl', require('./blades_ctrl'));